import React, { useState } from 'react';
import { Map } from 'lucide-react';
import { toast } from 'react-toastify';
import { seoAPI } from '../../../config/seo-api';
import { helpers } from '../../../utils/helpers';
import SeoProductList from './SeoProductList';
import SeoCategoryList from './SeoCategoryList';
import './Seo.css';

const SeoPage = ({ adminData }) => {
  const hasAccess = helpers.hasSeoAccess(adminData);
  const [activeTab, setActiveTab] = useState('products');
  const [creatingSitemap, setCreatingSitemap] = useState(false);
  const [lastSitemapCreatedAt, setLastSitemapCreatedAt] = useState(null);

  const handleCreateSitemap = async () => {
    try {
      setCreatingSitemap(true);
      const response = await seoAPI.createSitemap();

      if (response.success) {
        if (response.data?.lastSitemapCreatedAt) {
          setLastSitemapCreatedAt(response.data.lastSitemapCreatedAt);
        }
        const publicUrl = response.data?.publicUrl;
        const successMessage = publicUrl
          ? `${response.msg || 'Successfully created sitemap'} Public URL: ${publicUrl}`
          : (response.msg || 'Successfully created sitemap');

        if (response.downloaded) {
          toast.success(`${successMessage} Sitemap downloaded.`);
        } else {
          toast.warn(
            `${successMessage} File was created on the server, but automatic download failed.${
              publicUrl ? ` Open: ${publicUrl}` : ''
            }`
          );
        }
      } else {
        toast.error(response.msg || 'Failed to create sitemap');
      }
    } catch (error) {
      toast.error('Failed to create sitemap');
      console.error('Create sitemap error:', error);
    } finally {
      setCreatingSitemap(false);
    }
  };

  if (!hasAccess) {
    return (
      <div className="product-list-page">
        <div className="seo-no-access">
          <h2>Access Denied</h2>
          <p>You do not have permission to view the SEO section.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="product-list-page">
      <div className="page-header">
        <div className="page-title">
          <h1>SEO</h1>
          <p>Manage product and category search engine optimization settings</p>
        </div>
        <div className="sitemap-control-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <button
            type="button"
            className="seo-create-sitemap-button"
            onClick={handleCreateSitemap}
            disabled={creatingSitemap}
          >
            <Map size={18} />
            {creatingSitemap ? 'Creating...' : 'Create Sitemap'}
          </button>
          {lastSitemapCreatedAt && (
            <span className="last-sitemap-date" style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
              Last Created: {lastSitemapCreatedAt}
            </span>
          )}
        </div>
      </div>

      <div className="seo-main-tabs">
        <button
          type="button"
          className={`seo-main-tab ${activeTab === 'products' ? 'seo-main-tab-active' : ''}`}
          onClick={() => setActiveTab('products')}
        >
          Products
        </button>
        <button
          type="button"
          className={`seo-main-tab ${activeTab === 'categories' ? 'seo-main-tab-active' : ''}`}
          onClick={() => setActiveTab('categories')}
        >
          Categories
        </button>
      </div>

      {activeTab === 'products' ? (
        <SeoProductList
          adminData={adminData}
          embedded
          onLoadLastSitemapCreated={setLastSitemapCreatedAt}
        />
      ) : (
        <SeoCategoryList adminData={adminData} />
      )}
    </div>
  );
};

export default SeoPage;
